import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import { exportComponentAsJPEG } from "react-component-export-image";
import "./restaurantQR.styles.scss";
class TableSideQR extends React.Component {
  constructor(props) {
    super(props);
    this.hotelID = localStorage.getItem("hotelID");
    this.url =
      "https://waitrprototype.netlify.app/user/" + this.hotelID + "/tableside";
  }
  render() {
    return (
      <div className="qr-container">
        <div className="qr-box">
          <span className="qr-title">Tableside</span>
          <span className="qr-hotelname">Restaurant Name</span>
          <QRCodeCanvas
            id="qrcode1"
            value={this.url}
            bgColor="#fff"
            fgColor="#000"
          />
          <span className="qr-company-title">Powered by : Waitr</span>
        </div>
      </div>
    );
  }
}
class TakeawayQR extends React.Component {
  constructor(props) {
    super(props);
    this.hotelID = localStorage.getItem("hotelID");
    this.url =
      "https://waitrprototype.netlify.app/user/" + this.hotelID + "/takeaway";
  }
  render() {
    return (
      <div className="qr-container">
        <div className="qr-box">
          <span className="qr-title">Takeaway</span>
          <span className="qr-hotelname">Restaurant Name</span>
          <QRCodeCanvas
            id="qrcode1"
            value={this.url}
            bgColor="#fff"
            fgColor="#000"
          />
          <span className="qr-company-title">Powered by : Waitr</span>
        </div>
      </div>
    );
  }
}

export default class RestaurantQR extends React.Component {
  constructor(props) {
    super(props);
    this.takeawayRef = React.createRef();
    this.tablesideRef = React.createRef();
  }
  render() {
    return (
      <div className="restaurant-qr-container">
        {this.props.currentPage === "tableside" ? (
          <TableSideQR ref={this.tablesideRef} />
        ) : (
          <TakeawayQR ref={this.takeawayRef} />
        )}
        {this.props.currentPage === "tableside" ? (
          <button
            className="qr-download-button"
            onClick={() =>
              exportComponentAsJPEG(this.tablesideRef, {
                fileName: "TablesideQR.jpg",
              })
            }
          >
            Download QR
          </button>
        ) : (
          <button
            className="qr-download-button"
            onClick={() =>
              exportComponentAsJPEG(this.takeawayRef, {
                fileName: "TakeawayQR.jpg",
              })
            }
          >
            Download QR
          </button>
        )}
      </div>
    );
  }
}
